import { Container } from 'pixi.js';
import { getLocalizedValue } from '@softgames/localization';
import { LoseProgressBaseIcon } from '../../../../../../layouts/popups/failFlow/LoseProgressBaseIcon';

export class LoseProgressBaseIconView extends Container {
  public readonly layout = new LoseProgressBaseIcon();

  constructor() {
    super();

    const { root } = this.layout;

    root.props({
      parent: this,
    });
  }

  public injectIcon(view: Container): this {
    const {
      layout: { slot },
    } = this;

    view.props({
      parent: slot,
    });
    return this;
  }

  public setAmount(amount: number): this {
    const {
      layout: { amountText },
    } = this;

    amountText.text = `-${getLocalizedValue(amount)}`;
    return this;
  }

  public toggleAmountView(value: boolean): this {
    const {
      layout: { amountText },
    } = this;

    amountText.visible = value;
    return this;
  }
}
